import React, { Fragment } from 'react';
import { CardImg } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
const AivaProductListItem = ({
  item,
  SelectedProduct,
  handleProductId,
  SelectedProductID,
  w,
  productId,
  selectedItem,
  handleSelecteditem,
  voucher,
}) => {
  return (
    <Fragment>
      <div
        className={`row`}
        style={{ cursor: 'pointer' }}
        onClick={(e) =>
          null
        }
      >
      <div className='col-md-4' onClick={() => {
          let obj = productId;
          if (selectedItem.filter((f) => f === '0').length === 0) {
            if (selectedItem.filter((f) => f === '2').length > 0) {
              obj = '2' + "," + '0';
              obj.trim(',');
              let val = ['2', '0'];
              handleSelecteditem(val);
              handleProductId(obj);
            } else {
              obj = '0';
              obj.trim(',');
              handleProductId(obj);
              let val = ['0'];
              handleSelecteditem(val);
            }
          } else {
            if (selectedItem.filter((f) => f === '2').length > 0) {
              obj = '2';
              obj.trim(',');
              let val = ['2'];
              handleSelecteditem(val);
              handleProductId(obj);
            }else{
              handleSelecteditem([]);
              handleProductId('');
            } 
          }              
        }}>
          <div
            className={selectedItem.filter((f)=>f==='0').length > 0 ?'card col-md-12 aiva-border text-center':'card col-md-12 text-center temp-border'}
          >
            <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
              <div className="price-top-part">
                <h5 className="mb-0 font-weight-semibold color-theme-1 mb-3  text-center  aiva">
                  Pay-As-You-Go
                </h5>
                <div className="mb-3 text-default  text-center">
                  <p>Access the most important  <strong>aiva’s</strong> features...
                  </p>
                </div>
                <p className='text-center mb-2'>
                  <h2><strong> <span style={{ fontSize: '24px' }}>7</span><span style={{ fontSize: '16px' }}>%</span></strong></h2>
                </p>
                <p className='text-center mb-4'><strong>aiva</strong> Fee per voucher transaction</p>
                {/* <p className="text-muted text-small">+ 5% booking commission</p> */}
                {selectedItem.filter((f)=>f==='0').length > 0 && <i
                  className="demo-icon simple-icon-check activeSubscription"
                  id="nametip"
                ></i>}
              </div>
              <div className=" d-flex-justify-content-center flex-column flex-grow-1">
                <ul className='aiva-list-item '>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }} ></FontAwesomeIcon> <span className='ml-2'>Everything you need to manage and distribute vouchers</span>
                  </li>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon> <span className='ml-2'> No setup fee, monthly fees or hidden fees</span>
                  </li>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon><span className='ml-2'> Integrate your existing Stripe or PayPal account</span>
                  </li>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon>  <span className='ml-2'>Ongoing feature updates included</span>
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon> <span className='ml-2'> Invoiced end of the month for vouchers sold  </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-4' onClick={() => {
          let obj = productId;
          if (selectedItem.filter((f) => f === '1').length === 0) {
            if (selectedItem.filter((f) => f === '2').length > 0) {
              obj = '2' + "," + '1';
              obj.trim(',');
              let val = ['2', '1'];
              handleSelecteditem(val);
              handleProductId(obj);
            } else {
              obj = '1';
              obj.trim(',');
              handleProductId(obj);
              let val = ['1'];
              handleSelecteditem(val);
            }

          } else {
            if (selectedItem.filter((f) => f === '2').length > 0) {
              obj = '2';
              obj.trim(',');
              let val = ['2'];
              handleSelecteditem(val);
              handleProductId(obj);
            }else{
              handleSelecteditem([]);
              handleProductId('');
            } 
          }       
        }}>
          <div
            className={selectedItem.filter((f)=>f==='1').length > 0 ?'card col-md-12 aiva-border text-center':'card col-md-12 text-center temp-border'}
          >
            <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
              <div className="price-top-part">
                <h5 className="mb-0 font-weight-semibold color-theme-1 mb-3  text-center  aiva">
                Pay-As-You-Go Gateway
                </h5>
                <div className="mb-3 text-default  text-center">
                <p>Access the most important  <strong>aiva’s</strong> features...
                  </p>
                </div>
                <p className='text-center mb-2'>
                  <h2><strong> <span style={{ fontSize: '24px' }}>9</span><span style={{ fontSize: '16px' }}>%</span></strong></h2>
                </p>
                <p className='text-center mb-4'><strong>aiva</strong> Fee per voucher transaction</p>
                {/* <p className="text-muted text-small">+ 5% booking commission</p> */}
                    {selectedItem.filter((f)=>f==='1').length > 0 && <i
                  className="demo-icon simple-icon-check activeSubscription"
                  id="nametip"
                ></i>}
              </div>
              <div className=" d-flex-justify-content-center flex-column flex-grow-1">
                <ul className='aiva-list-item '>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }} ></FontAwesomeIcon> <span className='ml-2'>Everything you need to manage and distribute vouchers</span>
                  </li>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon> <span className='ml-2'>        No setup fee, monthly fees or hidden fees</span>
                  </li>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon><span className='ml-2'> Includes payment gateway/merchant fees using stripe</span>
                  </li>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon>  <span className='ml-2'>Ongoing feature updates included</span>
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon> <span className='ml-2'>  The <strong>aiva</strong> Fee is automatically deducted from the voucher transaction and the remaining balance instantly paid to you through your Stripe account.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-4' onClick={() => {
           let obj = productId;
           if (selectedItem.filter((f)=>f==='2').length > 0 ) {
             let val = [];

             if (selectedItem.filter((f) => f === '0').length > 0) {
               handleProductId('0');
               val.push('0')
             }
             if (selectedItem.filter((f) => f === '1').length > 0) {
               handleProductId('1');
               val.push('1');
             }
             handleSelecteditem(val);
           }
           else{
            let val = selectedItem;
            val.push('2');
            handleSelecteditem(val);
            obj =obj+ ","+ '2';
            obj.trim(',');
            handleProductId(obj);
           }

        }}>
          <div
            className={selectedItem.filter((f)=>f==='2').length > 0 ?'card col-md-12 aiva-border text-center':'card col-md-12 text-center temp-border'}
          >
            <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
              <div className="price-top-part">
                <h5 className="mb-0 font-weight-semibold color-theme-1 mb-3  text-center  aiva">
                Pay-As-You-Go Plus
                </h5>
                <div className="mb-3 text-default  text-center">
                  <p>Optional features available on top of our simple...
                  </p>
                </div>
                <p className='text-center mb-2'>
                  <h2><strong> <span style={{ fontSize: '16px' }}>$</span><span style={{ fontSize: '24px' }}>29/month</span></strong></h2>
                  <strong className='mt-1'>Optional</strong>
                </p>
                <p className='text-center mb-4'><strong>aiva</strong> Fee per voucher transaction</p>
                {/* <p className="text-muted text-small">+ 5% booking commission</p> */}
                {selectedItem.filter((f)=>f==='2').length > 0 && <i
                  className="demo-icon simple-icon-check activeSubscription"
                  id="nametip"
                ></i>}
              </div>
              <div className=" d-flex-justify-content-center flex-column flex-grow-1">
                <ul className='aiva-list-item '>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }} ></FontAwesomeIcon> <span className='ml-2'>Completely align appearance to your website</span>
                  </li>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon> <span className='ml-2'>Upload your own fonts</span>
                  </li>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon><span className='ml-2'>Online redemption with integration to popular booking engines</span>
                  </li>
                  <li className='justify-content-center my-3 '>
                    <FontAwesomeIcon icon={faCheck} style={{ color: 'green' }}  ></FontAwesomeIcon>  <span className='ml-2'>Create and print offline vouchers</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default React.memo(AivaProductListItem);
